import './LinkedFirm.scss';
import Component from './LinkedFirm.js';
export { LinkedFirmEdits } from './LinkedFirm.js';
export default Component;
